import { SAVE_SECRETS } from "./secretsActionTypes";

export const saveSecrets = (secret) => {
  return {
    type: SAVE_SECRETS,
    payload: secret,
  };
};
